import { render, staticRenderFns } from "./frontVenderContainer.vue?vue&type=template&id=255540af&"
import script from "./frontVenderContainer.vue?vue&type=script&lang=js&"
export * from "./frontVenderContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontVenderContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports